import { createFileRoute } from "@tanstack/react-router";
import CardSignViewPage from "@/site/pages/card-sign-view";

/**
 * Legacy `/card/sign/view/<magic_link>` — a signer's view of the SENT group card
 * (legacy `group_card_send_notify` mail, My Cards › Signed, thank-you mail to signers).
 * Its own page (2026-10-07), not the recipient read page. Same `read_slug` as `/card/read/<slug>`,
 * kept as a separate URL on purpose (Nick 2026-09-16): links are in the wild and the
 * two surfaces have always been distinct. `?t=&e=` are ignored (PRD 13 D18).
 */
export const Route = createFileRoute("/card/sign/view/$slug")({
  component: CardSignViewPage,
});
